import React from "react";

import {
  CampaignContactsScreen,
  CampaignOverviewScreen,
  ListsScreen,
  StepsScreen,
  CampaignSettingsScreen,
  DefaultValuesScreen,
  BlacklistImportScreen,
  ProfileScreen,
  ContactsImportScreen,
  AccessDenied,
} from "../screens";
import CreateEmailTemplate from "../screens/Marketing/components/Template/CreateEmailTemplate";
import CampaignActivityScreen from "../screens/Marketing/CampaignActivityScreen";
import {
  BLACKLIST_IMPORT_PATH,
  COMPANY_SCREEN_PATH,
  CREATE_TEMPLATE_PATH,
  TASK_PATH,
  DASHBOARD_PATH,
  DEFAULT_VALUES_PATH,
  EMAIL_MARKETING_CAMPAIGN_ACTIVITY_PATH,
  EMAIL_MARKETING_CAMPAIGN_CONTACTS_PATH,
  EMAIL_MARKETING_CAMPAIGN_OVERVIEW_PATH,
  EMAIL_MARKETING_CAMPAIGN_PATH,
  INBOX_SCREEN_PATH,
  EMAIL_MARKETING_CAMPAIGN_SETTINGS_PATH,
  EMAIL_MARKETING_ICP_CAMPAIGN_FLOW_PATH,
  EMAIL_MARKETING_STEPS_PATH,
  AI_EMAIL_MARKETING_CREATE_NEW_PROMPT_PATH,
  IMPORT_PATH,
  LIST_PATH,
  MEETINGSTEPS_PATH,
  MEETING_PATH,
  PEOPLE_SCREEN_PATH,
  PREVIEW_TEMPLATE_PATH,
  PROFILE_PATH,
  SEQUENCE_PATH,
  TEMPLATE_PATH,
  UPDATE_MEETING_PATH,
  UPDATE_TEMPLATE_PATH,
  CHROME_PATH,
  IMPORT_TABLE_CSV,
  CRM_PATH,
  PROPERTIES_PATH,
  FOLDER_LIST_PATH,
  CREATE_TEMPLATE_IN_FOLDER_PATH,
  SEQUENCE_PATH_WITH_PARENT,
  STEPS_WITH_FOLDER_PATH,
  EMAIL_MARKETING_CAMPAIGN_PATH_WITH_PARENT,
  UPDATE_TEMPLATE_IN_FOLDER_PATH,
  PROFILE_SECURITY_PATH,
  CONTACT_DETAIL_SCREEN,
  DASHBOARD_LIST_PATH,
  CONNECT_INBOX_PATH,
  ACCOUNT_PATH,
  DEALS_PATH,
  COMPANY_DETAIL_SCREEN,
  DASHBOARD_PATH_ID,
  DEALS_DETAIL_SCREEN,
  SNIPPET_PATH,
  SNIP_PATH,
  DEALS_BOARD_PATH,
  SNIPPET_FOLDER_PATH,
  MARKETING_PROSPECT_SCREEN_PATH,
  AI_EMAIL_MARKETING_PROMPT_GENERATE_PATH,
  MEMORY_PATH,
  COPILOT_HOME_PATH,
  COPILOT_CHAT_PATH,
  COPILOT_MONITOR_PATH,
  PAYMENT_SUCCESS_PATH,
  PAYMENT_CANCEL_PATH,
  ONBOARDING_PAYMENT_SUCCESS_PATH,
  ONBOARDING_PAYMENT_CANCEL_PATH,
  ICP_PROTOCOL_PATH,
  ICP_ANALYSIS_PATH,
  ACCESS_DENIED_PATH,
} from "../utils/constants/routes";
import ImportScreen from "../screens/CsvEnrichmentScreen/ImportScreen";
import { FOLDER_TEMPLATE_PATH } from "../utils/constants/routes";
import Properties from "../screens/PropertiesScreen/PropertiesScreen";
import Security from "../screens/ProfileScreen/components/Settings/Security";
import DashboardListScreen from "../screens/DashobardScreen/DashboardListScreen";
import ConnectInboxScreen from "../screens/DefaultScreens/ConnectInboxScreen";
import ContactsScreen from "../screens/CRM/Contacts/ContactsScreen";
import ContactDetailScreen from "../screens/CRM/Contacts/ContactDetailScreen";
import CompanyDetailScreen from "../screens/CRM/Account/CompanyDetailScreen";
// import DashboardScreen from "../screens/DashobardScreen/DashboardScreen";
import NewDashboardScreen from "../screens/DashobardScreen/NewDashboardScreen";
import AccountScreen from "../screens/CRM/Account/AccountScreen";
import DealsScreen from "../screens/CRM/Deals/DealsScreen";
import DealsDetailScreen from "../screens/CRM/Deals/DealsDetailScreen";
import CreatePromptScreen from "../screens/AIEmailMarketing/screens/CreatePromptScreen";
import PromptGenerationScreen from "../screens/AIEmailMarketing/screens/PromptLisitingScreen";
import MemoryScreen from "../screens/Memory/MemoryScreen";
import PaymentSuccess from "../screens/ProfileScreen/components/Settings/PaymentSuccess";
import PaymentCancel from "../screens/ProfileScreen/components/Settings/PaymentCancel";
import OnboardingPaymentSuccess from "../screens/ProfileScreen/components/Settings/OnboardingPaymentSuccess";
import OnboardingPaymentCancel from "../screens/ProfileScreen/components/Settings/OnboardingPaymentCancel";

const CopilotChatScreen = React.lazy(() => import("../screens/Copilot/CopilotChatScreen"));
const CopilotMonitorScreen = React.lazy(() => import("../screens/Copilot/CopilotMonitorScreen"));
const CopilotLandingScreen = React.lazy(() => import("../screens/Copilot/CopilotLandingScreen"));
const PeopleScreen = React.lazy(() => import("../screens/Leads/PeopleScreen"));
// const ImportPeopleScreen = React.lazy(() =>
//   import("../screens/Leads/ImportPeopleScreen")
// );
const CompanyScreen = React.lazy(
  () => import("../screens/Leads/CompanyScreen"),
);

// const DashboardScreen = React.lazy(() =>
//   import("../screens/DashobardScreen/DashboardScreen")
// );
const TaskScreen = React.lazy(() => import("../screens/TaskScreen/TaskScreen"));

const SequenceScreen = React.lazy(
  () => import("../screens/Marketing/SequenceScreen"),
);
const ICPCampaignFlowScreen = React.lazy(
  () => import("../screens/Marketing/ICPCampaignFlowScreen"),
);
const CampaignPipelineScreen = React.lazy(
  () => import("../screens/Marketing/CampaignPipeline"),
);
const CampaignScreen = React.lazy(
  () => import("../screens/Marketing/CampaignScreen"),
);
// INBOX (2026-08-24): full-screen unified inbox (Marketing > Inbox)
const InboxScreen = React.lazy(
  () => import("../screens/ProfileScreen/components/Settings/InboxSettings"),
);
const TemplateScreen = React.lazy(
  () => import("../screens/Marketing/TemplateScreen"),
);
const ChromeExtScreen = React.lazy(
  () => import("../screens/ChromeScreen/ChromeExtension"),
);
const MeetingScreen = React.lazy(
  () => import("../screens/MeetingScreen/Meeting/MeetingScreen"),
);
const MeetingCreateSteps = React.lazy(
  () => import("../screens/MeetingScreen/Meeting/MeetingCreateSteps"),
);

const SnippetScreen = React.lazy(
  () => import("../screens/SnippetScreen/SnippetDetail"),
);

const IcpProtocolScreen = React.lazy(
  () => import("../screens/IcpProtocol/IcpProtocolScreen"),
);

const IcpAnalysisScreen = React.lazy(
  () => import("../screens/IcpProtocol/IcpAnalysisScreen"),
);

export const userRoutes = [
  {
    path: PEOPLE_SCREEN_PATH,
    component: PeopleScreen,
  },
  {
    path: MARKETING_PROSPECT_SCREEN_PATH,
    component: PeopleScreen,
  },
  {
    path: IMPORT_PATH,
    component: ContactsImportScreen,
  },
  {
    path: ICP_PROTOCOL_PATH,
    component: IcpProtocolScreen,
  },
  {
    path: ICP_ANALYSIS_PATH,
    component: IcpAnalysisScreen,
  },
  {
    path: BLACKLIST_IMPORT_PATH,
    component: BlacklistImportScreen,
  },
  {
    path: CONNECT_INBOX_PATH,
    component: ConnectInboxScreen,
  },

  {
    path: COMPANY_SCREEN_PATH,
    component: CompanyScreen,
  },
  {
    path: DASHBOARD_PATH,
    component: NewDashboardScreen,
  },
  // {
  //   path: DASHBOARD_PATH,
  //   component: DashboardScreen,
  // },
  // {
  //   path: DASHBOARD_PATH_ID,
  //   component: DashboardScreen,
  // },
  {
    path: TASK_PATH,
    component: TaskScreen,
  },
  {
    path: MEETING_PATH,
    component: MeetingScreen,
  },
  {
    path: MEETINGSTEPS_PATH,
    component: MeetingCreateSteps,
  },
  {
    path: UPDATE_MEETING_PATH,
    component: MeetingCreateSteps,
  },
  {
    path: SEQUENCE_PATH,
    component: SequenceScreen,
  },
  {
    path: SEQUENCE_PATH_WITH_PARENT,
    component: SequenceScreen,
  },
  {
    path: EMAIL_MARKETING_STEPS_PATH,
    component: StepsScreen,
  },
  {
    path: STEPS_WITH_FOLDER_PATH,
    component: StepsScreen,
  },
  {
    path: EMAIL_MARKETING_CAMPAIGN_PATH,
    component: CampaignScreen,
  },
  {
    path: INBOX_SCREEN_PATH,
    component: InboxScreen,
  },
  {
    path: EMAIL_MARKETING_CAMPAIGN_PATH_WITH_PARENT,
    component: CampaignScreen,
  },
  {
    path: EMAIL_MARKETING_ICP_CAMPAIGN_FLOW_PATH,
    component: CampaignPipelineScreen,
  },
  {
    path: EMAIL_MARKETING_CAMPAIGN_OVERVIEW_PATH,
    component: CampaignOverviewScreen,
  },
  {
    path: EMAIL_MARKETING_CAMPAIGN_CONTACTS_PATH,
    component: CampaignPipelineScreen,
  },
  {
    path: EMAIL_MARKETING_CAMPAIGN_ACTIVITY_PATH,
    component: CampaignActivityScreen,
  },
  {
    path: EMAIL_MARKETING_CAMPAIGN_SETTINGS_PATH,
    component: CampaignSettingsScreen,
  },
  {
    path: AI_EMAIL_MARKETING_PROMPT_GENERATE_PATH,
    component: PromptGenerationScreen,
  },
  {
    path: AI_EMAIL_MARKETING_CREATE_NEW_PROMPT_PATH,
    component: CreatePromptScreen,
  },
  {
    path: LIST_PATH,
    component: ListsScreen,
  },
  {
    path: PROFILE_PATH,
    component: ProfileScreen,
  },
  {
    path: PROFILE_SECURITY_PATH,
    component: Security,
  },
  {
    path: TEMPLATE_PATH,
    component: TemplateScreen,
  },

  {
    path: CREATE_TEMPLATE_PATH,
    component: CreateEmailTemplate,
  },
  {
    path: CREATE_TEMPLATE_IN_FOLDER_PATH,
    component: CreateEmailTemplate,
  },
  {
    path: UPDATE_TEMPLATE_IN_FOLDER_PATH,
    component: CreateEmailTemplate,
  },
  {
    path: UPDATE_TEMPLATE_PATH,
    component: CreateEmailTemplate,
  },
  {
    path: PREVIEW_TEMPLATE_PATH,
    component: CreateEmailTemplate,
  },
  {
    path: DASHBOARD_LIST_PATH,
    component: DashboardListScreen,
  },
  {
    path: DEFAULT_VALUES_PATH,
    component: DefaultValuesScreen,
  },
  {
    path: FOLDER_TEMPLATE_PATH,
    component: TemplateScreen,
  },
  {
    path: FOLDER_LIST_PATH,
    component: ListsScreen,
  },

  {
    path: CHROME_PATH,
    component: ChromeExtScreen,
  },
  {
    path: IMPORT_TABLE_CSV,
    component: ImportScreen,
  },
  {
    path: CRM_PATH,
    component: ContactsScreen,
  },
  {
    path: DEALS_PATH,
    component: DealsScreen,
  },
  {
    path: DEALS_BOARD_PATH,
    component: DealsScreen,
  },
  {
    path: PROPERTIES_PATH,
    component: Properties,
  },
  {
    path: CONTACT_DETAIL_SCREEN,
    component: ContactDetailScreen,
  },
  {
    path: ACCOUNT_PATH,
    component: AccountScreen,
  },
  {
    path: COMPANY_DETAIL_SCREEN,
    component: CompanyDetailScreen,
  },
  {
    path: DEALS_DETAIL_SCREEN,
    component: DealsDetailScreen,
  },
  {
    path: SNIPPET_PATH,
    component: SnippetScreen,
  },
  {
    path: SNIPPET_FOLDER_PATH,
    component: SnippetScreen,
  },
  {
    path: MEMORY_PATH,
    component: MemoryScreen,
  },
  {
    path: COPILOT_HOME_PATH,
    component: CopilotLandingScreen,
  },
  {
    path: COPILOT_CHAT_PATH,
    component: CopilotChatScreen,
  },
  {
    path: COPILOT_MONITOR_PATH,
    component: CopilotMonitorScreen,
  },
  {
    path: PAYMENT_SUCCESS_PATH,
    component: PaymentSuccess,
  },
  {
    path: PAYMENT_CANCEL_PATH,
    component: PaymentCancel,
  },
  {
    path: ONBOARDING_PAYMENT_SUCCESS_PATH,
    component: OnboardingPaymentSuccess,
  },
  {
    path: ONBOARDING_PAYMENT_CANCEL_PATH,
    component: OnboardingPaymentCancel,
  },
  {
    path: ACCESS_DENIED_PATH,
    component: AccessDenied,
  },
];
